export const omega2k = 'Patrick 🥦 omega2k';
